import React from 'react';
import ReactDOM from 'react-dom';
import { Link } from 'react-router';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import axios from 'axios';
import Loading from '../../components/Loading';
import NoResult from '../../components/general/NoResult';
import BillingInformation from './form/BillingInformation.js';
import SplitRows from '../../components/general/SplitRow.js';
import OptionColumn from '../../components/general/OptionColumn.js';
import Notification from '../../components/Notification.js'
import General from '../../modules/General';
class Settings extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			'packages':[],
			'isLoading':true,
			'error':false
		}

	}


	selectPackage(package_id) {
		let current = this.props.general.account.downgrade_package ? this.props.general.account.downgrade_package.id:this.props.general.account.package.id;

		if(current == package_id) {
			this.props.router.push(General.Link('/settings/billing'));
		}else{
			this.setState({'isLoading':true});
			axios.put('/subscriptions/plan',{package_id}).then(res => {
				this.setState({'isLoading':false});
				Notification.success('Plan successfully changed.');
				this.props.router.push(General.Link('/settings/billing'));
			}).catch(err => {
				this.setState({'isLoading':false});
				Notification.error(err.response.data.error.message);
			});
		}
	}



	componentWillMount() {
        this.props.router.push(General.Link('/settings/billing/subscribe'));
    }

	render() {

		if(this.state.isLoading) {
			return (
				<Loading error={false} />
			);
		}

		let current = this.props.general.account.downgrade_package ? this.props.general.account.downgrade_package.id:this.props.general.account.package.id;

		return (

				<div className="full-height">
				<div className="page-header">
					<span className="page-title"><i className="icon wb-payment"></i> Subscribe</span>
				</div>

				<div className="page-content">

					<div className="pricing-table">
						{this.state.packages.map((p,i) => {


							return (

							<div key={i} className={`pricing-column-five ${current == p.id  ? 'featured':''}`}>
								<div className="pricing-header">
									<div className="pricing-price">
										<span className="pricing-currency">$</span>
										<span className="pricing-amount">{p.price}</span>
										<span className="pricing-period">/ mo</span>
									</div>
									<div className="pricing-title">{p.name}</div>
								</div>
								<ul className="pricing-features">
									{p.data.map((data,i) => {
										return (
											<li key={i}>
												{data.description}
											</li>
										)
									})}


								</ul>
								<div className="pricing-footer">
									<button onClick={(e) => {e.stopPropagation(); this.selectPackage(p.id)}} className="btn btn-dark"><i className="icon wb-arrow-right font-size-16 m-r-15" aria-hidden="true"></i>
									{
                                        current == p.id
										?
										<span>Stay on same plan</span>
										:
										<span>Select plan</span>
									}
									</button>
								</div>
							</div>
							)
						})}
					</div>

					<div className="row">
						<div className="col-sm-12 text-center m-t-20">
							<Link to={General.Link('/settings/billing/cancel')}>Click here if you wish to cancel your account</Link>
						</div>
					</div>


				</div>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		auth:state.auth,
		general:state.general,
	}
}

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({},dispatch)
}


Settings = connect(mapStateToProps,mapDispatchToProps)(Settings);
export default Settings;



// WEBPACK FOOTER //
// ./containers/settings/BillingPlan.js